export const PAYMENT_MODES = {
	creditCard: "card",
	ACHTransfer: "ach_transfert",
	banksChecks: "bank_check",
	ACHDebit: "ach_debit",
};
